export enum ChampRD_Type {
    Text,
    Boolean,
    ComboBox,
    Champs,
    DateTemps,
    Image,
    Nombre,
    html,
    icomeMaterial,
    Bouton = 100
  }